import { render, staticRenderFns } from "./MenuLateralPerfil.vue?vue&type=template&id=345824d2&scoped=true"
import script from "./MenuLateralPerfil.vue?vue&type=script&lang=js"
export * from "./MenuLateralPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345824d2",
  null
  
)

export default component.exports